<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" variant="info" fixed="top" class="custom-info">
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav class="justify-content-md-center">
        <b-navbar-nav>
          <b-nav-item to="/">Home</b-nav-item>
          <b-nav-item to="/about">About</b-nav-item>
          <b-nav-item to="/portfolio">Portfolio</b-nav-item>
          <b-nav-item to="/contact">Contact</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <transition enter-active-class="animated fadeIn">
      <router-view />
    </transition>
    <footer class="text-muted footer-custom">
      <div class="container">
        <div class="row justify-content-center">
          <div class="text-center text-sm-right col-sm order-sm-3 col-12">
            <img
              src="@/assets/img/logo.webp"
              alt="logo"
              width="100"
              class="mb-4 mt-0 mt-sm-4 img-fluid"
            />
          </div>
          <div class="text-left col-md-4 col-auto">
            <h5 class="bd-text-purple-bright mb-1">Reach Me Faster</h5>
            <p>On Telegram: <a href="https://t.me/rzwibowo" target="_blank">rzwibowo</a></p>
            <p>
              Wibowo Devs' personal website. Hosted on <a href="https://firebase.google.com" target="_blank">Firebase</a>. Built with <a href="https://vuejs.org" target="_blank">Vue.js</a>.
            </p>
            <p>&copy; 2017 - {{ currentYear }} <a href="https://github.com/rzwibowo" target="_blank">rzwibowo</a> </p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      currentYear: new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss">
#app > div {
  min-height: 100vh;
}
</style>
